/** */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { addDataToStore } from 'store/actions/user-data';
import { formIsEmpty } from 'utilities/form';
import { Alert } from 'app/shared/form-alert';
import { Button } from 'app/shared/button';
import { IconInput, SimpleInput } from 'app/shared/input';
import styles from '../guest.module.css';
import { useAdminService } from 'hooks/api/users/admin';

const LoginForm = () => {
  const [alert, setAlert] = useState({});
  const [form_data, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [show_password, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const navigateTo = useNavigate();
  const { login } = useAdminService();

  const submitForm = async () => {
    if (formIsEmpty(form_data)) {
      setAlert({ message: 'Please fill all fields.' });
      return;
    }

    if (!form_data.email) {
      setAlert({ message: 'Invalid Email Address.' });
      return;
    }

    if (form_data.password.length < 8) {
      setAlert({ message: 'Passwords must contain 8 or more characters.' });
      return;
    }

    setLoading(true);
    login({ data: form_data })
      .then(({ tenant, error }) => {
        if (error) {
          setAlert({ message: error });
          return;
        }

        dispatch(addDataToStore(tenant));
      })
      .finally(() => setLoading(false));
  };

  const toggleShowPassword = () => {
    setShowPassword(!show_password);
  };

  return (
    <div>
      <Alert {...alert} />
      <SimpleInput
        placeholder="Email address"
        onInput={(value) => setFormData({ ...form_data, email: value })}
        value={form_data.email}
      />
      <IconInput
        placeholder="Password"
        icon_name={show_password ? 'hide' : 'show'}
        type={show_password ? 'text' : 'password'}
        icon_position="right"
        onInput={(value) => setFormData({ ...form_data, password: value })}
        onIconClick={toggleShowPassword}
        value={form_data.password}
      />
      <div className={styles.formText} onClick={() => navigateTo('/password/recovery')}>
        Recover password?
      </div>
      <Button
        className={styles.formBtn}
        onClick={() => submitForm()}
        text="Log In"
        loading={loading}
      />
      <Button
        className={styles.formBtn}
        onClick={() => navigateTo('/register')}
        text="Create Account"
        type="secondary"
      />
    </div>
  );
};

export default LoginForm;
